import mapUserFromApi from '@sdk/users/utils/mapUserFromApi';
import { UserFromApi } from '@sdk/users/types/UserFromApi';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';
import { PersonaCollection } from '@sdk/personaCollection/types/PersonaCollection';
import { User } from '@sdk/users/types/User';
import { ObjectWithId } from '@sdk/common/types/ObjectWithId';

import { isMessageUser } from './guards';

export function getMessageUser(
  user: UserFromApi | ObjectWithId,
  personaCollection: PersonaCollection,
  currentUser: AuthUserType
) {
  const { personasDict: personas } = personaCollection;
  let messageUser = personas[user.id] as User;
  if (isMessageUser(user)) {
    const groupIds = user.groupIds || [];
    messageUser = mapUserFromApi({ ...user, groupIds } as UserFromApi, currentUser, personas);
  }

  return messageUser;
}
